import { useTranslation } from 'react-i18next';

import { Badge } from '@saas-kit/ui';

interface Props {
  status: string;
}

const VARIANT: Record<string, 'success' | 'warning' | 'secondary' | 'outline'> = {
  active: 'success',
  suspended: 'warning',
  archived: 'secondary',
};

export function TenantStatusBadge({ status }: Props): JSX.Element {
  const { t } = useTranslation('adminTenants');
  const variant = VARIANT[status] ?? 'outline';
  return <Badge variant={variant}>{t(`status.${status}`, status)}</Badge>;
}
